<app-not-authorized-notice has="deviceManagement"></app-not-authorized-notice>

@if (hasDeviceManagement) {
	<app-tab-navigation-header i18n-title="@@Access" title="Device Access">
		<mat-tab-group appQueryStringTabGroup>
			<!-- <mat-tab i18n-label="grant access controls|@@accessMain-controls" label="Controls">
      <ng-template matTabContent>
        <app-device-controls [appBreadcrumbLabel]="controlsBreadcrumbLabel"></app-device-controls>
      </ng-template>
    </mat-tab> -->
			<mat-tab
				i18n-label="User Access Label|@@accessMain-userAccess"
				label="User Access"
				data-automation-id="user-access-tab"
			>
				<ng-template matTabContent>
					<app-user-access
						[appBreadcrumbLabel]="userAccessBreadcrumbLabel"
						[devices]="this.devices"
						[companyId]="companyId"
					></app-user-access>
				</ng-template>
			</mat-tab>
			<mat-tab
				i18n-label="Company access label|@@accessMain-companyAccess"
				label="Company Access"
				data-automation-id="company-access-tab"
			>
				<ng-template matTabContent>
					<app-company-access
						[appBreadcrumbLabel]="companyAccessBreadcrumbLabel"
						[devices]="this.devices"
						[companyId]="companyId"
					></app-company-access>
				</ng-template>
			</mat-tab>
		</mat-tab-group>
	</app-tab-navigation-header>
}
